import { fromEventTarget } from '@/utils'
import { useCallback } from 'react'
import { Input } from '../../styled'
import { FormItem } from './Component'

interface FormInputProps {
  name: string
  label?: string
  initialValue?: string
  defaultValue?: string
  info?: string
  helperText?: string
  ignoreErrorKeys?: string[]
  disabled?: boolean
  darkInfo?: boolean
  showErrorHelperText?: boolean
  noMargin?: boolean
  hideArrows?: boolean
  type?: 'number'
  placeholder?: string
}

interface ComponentProps {
  onChange?: (event: Event) => void
}

export const FormInput = ({
  name,
  label,
  initialValue,
  info,
  helperText,
  ignoreErrorKeys,
  disabled,
  darkInfo,
  showErrorHelperText,
  noMargin,
  hideArrows,
  type,
  ...props
}: FormInputProps) => {
  // TODO: remove useless useCallback.
  // Make sure the change to `disabled` works correctly
  const Component = useCallback(
    ({ onChange, ...field }: ComponentProps) => (
      <Input
        onChange={fromEventTarget(onChange)}
        {...field}
        disabled={disabled}
        id={name}
        name={name}
        {...props}
        hideArrows={hideArrows}
      />
    ),
    [disabled],
  )

  return (
    <FormItem
      darkInfo={darkInfo}
      helperText={helperText}
      ignoreErrorKeys={ignoreErrorKeys}
      info={info}
      initialValue={initialValue}
      label={label}
      name={name}
      showErrorHelperText={showErrorHelperText}
      noMargin={noMargin}
    >
      <Component />
    </FormItem>
  )
}
